import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';
import config from '../config';
import { useLocation, useNavigate } from 'react-router-dom';

import { Container, TextField, Checkbox, FormControlLabel, Button, Typography, Box, styled } from '@mui/material';

import Sidebar from '../components/Sidebar';
import { ContentContainer, PageContainer } from '../components/ContentContainer';

const CopyRetailerProjections = () => {
    const navigate = useNavigate();
    const [retailers, setRetailers] = useState([]);
    const [retailerFrom, setRetailerFrom] = useState(null);
    const [retailersTo, setRetailersTo] = useState([]);
    const [products, setProducts] = useState('');
    const [copyResult, setCopyResult] = useState(null);
    const [copyVideoScenes, setCopyVideoScenes] = useState(false);
    const [copy360, setCopy360] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Fetch retailers from the backend
        axios.get(`${config.serverUrl}/retailers`)
            .then(response => {
                const options = response.data.map(retailer => ({
                    value: retailer[0],
                    label: retailer[1]
                }));
                setRetailers(options);
            })
            .catch(error => {
                console.error('There was an error fetching the retailers!', error);
            });
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        const productsList = products.split(',').map(item => item.trim());
        const retailerIdsTo = retailersTo.map(item => item.value);

        axios.post(`${config.serverUrl}/render/copy_from`, {
            retailer_from: retailerFrom.value,
            retailers_to: retailerIdsTo,
            products: productsList,
            copy_video_scenes: copyVideoScenes,
            copy_360: copy360,
        })
        .then(response => {
            setCopyResult(response.data.copy_list);
        })
        .catch(error => {
            console.error('There was an error copying the products!', error);
        })
        .finally(() => {
            setIsLoading(false);
        });
    };

    return (
        <PageContainer>
            <Sidebar navigate={navigate} />
            <ContentContainer>
                <Container maxWidth="sm">
                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        justifyContent="center"
                        height="100vh"
                    >
                        <div>
                            <h1>Copy Render</h1>
                            <form onSubmit={handleSubmit}>
                                <div>
                                    <label>Retailer From:</label>
                                    <Select
                                        options={retailers}
                                        onChange={setRetailerFrom}
                                        value={retailerFrom}
                                        placeholder="Select a retailer"
                                        isDisabled={isLoading} // Disable during loading
                                    />
                                </div>
                                <div>
                                    <label>Retailers To:</label>
                                    <Select
                                        options={retailers}
                                        onChange={setRetailersTo}
                                        value={retailersTo}
                                        isMulti
                                        placeholder="Select one or more retailers"
                                        isDisabled={isLoading} // Disable during loading
                                    />
                                </div>
                                <div>
                                    <label>Product IDs (comma-separated):</label>
                                    <TextField
                                        type="text"
                                        value={products}
                                        onChange={(e) => setProducts(e.target.value)}
                                        placeholder="Enter product IDs"
                                        fullWidth
                                        disabled={isLoading} // Disable during loading
                                    />
                                </div>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={copyVideoScenes}
                                        onChange={(e) => setCopyVideoScenes(e.target.checked)}
                                        color="primary"
                                      />
                                    }
                                    label="Copy Video Scenes"
                                  />
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={copy360}
                                        onChange={(e) => setCopy360(e.target.checked)}
                                        color="primary"
                                      />
                                    }
                                    label="Copy 360"
                                  />
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    style={{ marginTop: '20px' }}
                                    disabled={isLoading} // Disable button during loading
                                >
                                    {isLoading ? 'Copying...' : 'Copy Render'}
                                </Button>
                            </form>

                            {copyResult && (
                                <div>
                                    <h2>Copy Results</h2>
                                    <div style={{
                                        maxHeight: '40vh',
                                        overflowY: 'auto',
                                        border: '1px solid #e0e0e0',
                                        padding: '10px',
                                        borderRadius: '6px',
                                        background: '#fafafa',
                                        marginTop: '8px'
                                    }}>
                                        <ul style={{ margin: 0 }}>
                                            {copyResult.map((item, index) => (
                                                <li key={index}>Copied from {item[0]} to {item[1]}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Box>
                </Container>
            </ContentContainer>
        </PageContainer>
    );
};

export default CopyRetailerProjections;
